import OutLineMobileSeven from '@assets/icons/outline-mobile-seven.svg'
import { Icon } from './Icon'

export const OutLineMobileSevenIcon = Icon(OutLineMobileSeven)
